import { createContext, Dispatch, SetStateAction } from 'react';
import { BreadcrumbItem } from './types';

export type BreadcrumbsContextType = {
  items: BreadcrumbItem[];
  setItems: Dispatch<SetStateAction<BreadcrumbItem[]>>;
};

export const BreadcrumbsContext = createContext<BreadcrumbsContextType | null>(null);
